import React from "react";
import { Button, Tooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class Go2Top extends React.Component {
  constructor() {
    super();
    this.state = {
      tooltipOpen: false
    };
  }

  render() {
    const { t } = this.props;
      return (
        <div className='fixedToTop' style={{display: this.props.visible ? 'block' : 'none'}}>
          <Button id={"popoverTop"} onClick={this.props.onClick} className='cortxt70 b-none bknone sombra bkbranco'>
            <FontAwesomeIcon icon={["fa", "arrow-up"]} fixedWidth={true} />
          </Button>
          <Tooltip placement='left' target={"popoverTop"} toggle={() => this.setState({ tooltipOpen: !this.state.tooltipOpen })} isOpen={this.state.tooltipOpen}>
            {t("VoltarAoTopo")}
          </Tooltip>
        </div>
      );
  }
}
